<ng-container *ngIf="!this.isOperatorView; else operatorRegister">
  <ng-container>

    <body class="body-form-signin register-bg"
      [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">
      <main class="form-register" *ngIf="!user.isPasswordSet">
        <form class="form-shadow was-validated hide-valid-feedback p-4" [formGroup]="formService.form"
          autocomplete="off" novalidate (ngSubmit)="registerUser(formService.form.value)" *ngIf="formCreated">
          <div class="justify-content-center">
            <div class="justify-content-center">
              <app-message [service]="messageService"></app-message>
              <div class="text-center">
                <a href="https://cubos.com" target="_blank" *ngIf="!whitelabel || whitelabel == 'cubos'">
                  <img class="mb-4" src="assets/images/cubos_connect_logo_4c.svg" alt="CUBOS.Connect" width="272">
                </a>
                <a *ngIf="whitelabel">
                  <img class="logo mb-4" [src]="whitelabelURL + whitelabel + '/logo.png'" [alt]="whitelabel">
                </a>
                <div class="col-md-12 col mb-14 ">
                  <h3 class="font-weight-bold ml-md-0 mx-auto text-center" i18n="@@RegisterHeader">
                    Registrierungsformular
                  </h3>
                </div>
              </div>
            </div>

            <div class="container justify-content-center round">
              <div class="col-lg-12 col-md-12">
                <div class="row justify-content-center">
                  <div class=" col-md-12 col-lg-10 col-12 mt-3">
                    <div class="form-group" style="display:none;">
                      <label for="type" i18n="@@UserTypeLabel" style="display:none;">Privat / Geschäftlich*</label>
                      <input type="hidden" id="type" formControlName="type" value="company">
                    </div>

                    <div *ngIf="isTypeCompany()" class="form-group">
                      <label for="company" i18n="@@CompanyLabel">Unternehmen*</label>
                      <input type="text" id="company" formControlName="company" class="form-control"
                        i18n-placeholder="@@Company" placeholder="Unternehmen*"
                        [ngClass]="{ 'is-invalid': formService.validateControl('company') }" />

                      <div class="error">
                        <em
                          *ngIf="formService.validateControl('company') && formService.hasError('company', 'required')"
                          i18n="@@CompanyRequiredError">Unternehmen wird benötigt</em>
                      </div>
                    </div>

                  </div>
                  <div class=" col-12">
                    <div class="form-group">

                      <div FormGroupName="UserName">

                        <div class="form-group position-relative mb-2">
                          <label for="gender" required i18n="@@TitleLabel">Anrede*</label>
                          <select id="gender" formControlName="gender" class="form-select"
                            [ngClass]="{ 'is-invalid': formService.validateControl('gender') }">
                            <option value="" disabled selected i18n="@@Titleselect">bitte Anrede wählen...</option>
                            <option value="male" i18n="@@TitleMrOption">Herr</option>
                            <option value="female" i18n="@@TitleMrs_MsOption">Frau</option>
                            <option value="diverse" i18n="@@TitleDiversOption">Divers</option>
                          </select>
                          <div class="error">
                            <em
                              *ngIf="formService.validateControl('gender') && formService.hasError('gender', 'required')"
                              i18n="@@TitleRequiredError">Anrede wird benötigt</em>
                          </div>
                        </div>

                        <div class="form-group position-relative mb-2">
                          <label for="firstName" i18n="@@FirstnameLabel">Vorname*</label>
                          <input type="text" id="firstName" formControlName="firstName" class="form-control"
                            i18n-placeholder="@@FirstName" placeholder="Vorname*"
                            [ngClass]="{ 'is-invalid': formService.validateControl('firstName') }" />
                          <div class="error">
                            <em
                              *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'required')"
                              i18n="@@FirstnameRequiredError">
                              Vorname wird benötigt
                            </em>
                            <em
                              *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')"
                              i18n="@@IncorrectInputError">
                              Falsche Eingabe
                            </em>
                            <em
                              *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'maxlength')"
                              i18n="@@ExceededMaxLengthError">
                              Die Eingabe darf maximal 50 Zeichen lang sein
                            </em>
                          </div>
                        </div>

                        <div class="form-group position-relative mb-2">
                          <label for="lastName" i18n="@@LastnameLabel">Nachname*</label>
                          <input type="text" id="lastName" formControlName="lastName" class="form-control"
                            i18n-placeholder="@@LastName" placeholder="Nachname*"
                            [ngClass]="{ 'is-invalid': formService.validateControl('lastName') }" />
                          <div class="error">
                            <em
                              *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')"
                              i18n="@@LastnameRequiredError">
                              Nachname wird benötigt
                            </em>
                            <em class="invalid-tooltip"
                              *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')"
                              i18n="@@IncorrectInputError">
                              Falsche Eingabe
                            </em>
                            <em class="invalid-tooltip"
                              *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'maxlength')"
                              i18n="@@ExceededMaxLengthError">
                              Die Eingabe darf maximal 50 Zeichen lang sein
                            </em>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-row row" formGroupName="address">
                      <div class="form-group position-relative col-8 mb-2">
                        <label for="street" i18n="@@StreetLabel">Straße*</label>
                        <input type="text" id="street" formControlName="street" class="form-control"
                          i18n-placeholder="@@Street" placeholder="Straße*"
                          [ngClass]="{ 'is-invalid': formService.validateControl('address.street') }" />
                        <div class="error">
                          <em
                            *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'required')"
                            i18n="@@StreetRequiredError">
                            Straße wird benötigt
                          </em>
                          <em
                            *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'pattern')"
                            i18n="@@IncorrectInputError">
                            Falsche Eingabe
                          </em>
                        </div>
                      </div>

                      <div class="form-group position-relative col-4 mb-2">
                        <label for="houseNumber" i18n="@@HousnumberLabel">Hausnummer*</label>
                        <input (change)="trimValue($event)" type="text" id="houseNumber" formControlName="houseNumber"
                          class="form-control" i18n-placeholder="@@Housenumber" placeholder="Hausnummer"
                          [ngClass]="{ 'is-invalid': formService.validateControl('address.houseNumber') }" />
                        <div class="error">
                          <em
                            *ngIf="formService.validateControl('address.houseNumber') && formService.hasError('address.houseNumber', 'required')"
                            i18n="@@HousnumberRequiredError">
                            Hausnummer wird benötigt
                          </em>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-row row" formGroupName="address">
                      <div class="form-group position-relative col-4 mb-2">
                        <label for="postalCode" i18n="@@postalCodeLabel">PLZ*</label>
                        <input type="text" id="postalCode" formControlName="postalCode" class="form-control"
                          placeholder="PLZ*" maxlength="6" i18n-placeholder="@@postalCode" />
                        <div class="error">
                          <em
                            *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'required')"
                            i18n="@@postalCodeRequiredError">
                            PLZ wird benötigt
                          </em>
                          <em
                            *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'pattern')"
                            i18n="@@IncorrectInputError">
                            Falsche Eingabe
                          </em>
                          <em
                            *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'maxlength')"
                            i18n="@@ExceededMaxLengthPLZError">
                            Die Eingabe darf maximal 6 Zeichen lang sein
                          </em>
                          <em
                            *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'minlength')"
                            i18n="@@MissingNumbersPLZError">
                            PLZ zu kurz
                          </em>

                        </div>
                      </div>

                      <div class="form-group position-relative col-8 mb-2">
                        <label for="city" i18n="@@CityLabel">Ort*</label>
                        <input (change)="trimValue($event)" type="text" id="city" formControlName="city"
                          class="form-control" placeholder="Ort*"
                          [ngClass]="{ 'is-invalid': formService.validateControl('address.city') }" />
                        <div class="error">
                          <em
                            *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'required')"
                            i18n="@@CityRequiredError">
                            Ort wird benötigt
                          </em>
                          <em
                            *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'pattern')"
                            i18n="@@IncorrectInputError">
                            Falsche Eingabe
                          </em>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-row row" formGroupName="address">
                      <div class="form-group position-relative col-4 mb-2">
                        <label for="country" i18n="@@CountryLabel">Land</label>
                        <input (change)="trimValue($event)" type="text" id="country" formControlName="country"
                          class="form-control" placeholder="Land" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-row row">
                      <div class="form-group position-relative col-12 mb-2">
                        <label for="phone" i18n="@@PhoneLabel">Telefon*</label>
                        <input (change)="trimValue($event)" type="text" id="phone" formControlName="phone"
                          class="form-control" placeholder="Telefon*" minlength="6" />
                        <div class="error">
                          <em *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'required')"
                            i18n="@@PhonenumberRequiredError">
                            Telefonnummer wird benötigt
                          </em>
                          <em *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'pattern')"
                            i18n="@@IncorrectInputError">
                            Falsche Eingabe
                          </em>
                          <em *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'minlength')"
                            i18n="@@MinLengthError">
                            Telefonnummer zu kurz
                          </em>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-lg-12 col-md-12 mb-2">
                <div class="row justify-content-center">
                  <div class="col-lg-10 col-md-12 col-12">
                    <div class="row justify-content-center">
                      <div class="form-group text-center">
                        <hr>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group position-relative mb-2">
                      <label for="email" i18n="@@E-MailLabel">E-Mail*</label>
                      <input type="email" id="email" formControlName="email" class="form-control"
                        i18n-placeholder="@@E-Mail" placeholder="E-Mail" [readonly]="token != null"
                        (blur)="checkEmail()" />
                      <div class="error">
                        <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'required')"
                          i18n="@@E-mailRequiredError">
                          E-Mail wird benötigt
                        </em>
                        <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'email')"
                          i18n="@@IncorrectInputError">
                          Keine gültige E-Mail eingegeben
                        </em>
                        <em *ngIf="this.emailExists && token == null">
                          Diese Email existiert bereits
                        </em>
                      </div>
                    </div>
                  </div>
                  <div class=" col-12">
                    <div class="form-group position-relative mb-2">
                      <!-- <label class="persistent" for="password" data-toggle="tooltip" i18n="@@ChoosePasswordLabel">Passwort* <span *ngIf="passwordRating != ''" [class]="'password-rating-' + passwordQuality">({{ passwordRating }})</span></label> -->
                      <label class="persistent" for="password" data-toggle="tooltip"
                        i18n="@@ChoosePasswordLabel">Passwort*</label>
                      <input type="password" id="password" formControlName="password"
                        (keyup)="checkPassword($event.target.value)" class="form-control" i18n-placeholder="@@Password"
                        placeholder="Passwort*" [ngClass]="{ 'is-invalid': formService.validateControl('password') }" />
                      <div class="password-requirements">
                        <span [class]="passwordHasUpperCase ? 'check' : ''"
                          i18n="@@CapitalLetterHint">Großbuchstabe</span>
                        <span [class]="passwordHasLowerCase ? 'check' : ''"
                          i18n="@@LowercaseLetterHint">Kleinbuchstabe</span>
                        <span [class]="passwordHasDigit ? 'check' : ''" i18n="@@DigitHint">Ziffer</span>
                        <span [class]="passwordHasLength ? 'check' : ''" i18n="@@10CharactersLongHint">10 Zeichen
                          lang</span>
                        <span *ngIf="passwordHasSpecialCharacter" [class]="passwordHasSpecialCharacter ? 'check' : ''"
                          i18n="@@SpecialCharacterHint">Sonderzeichen</span>
                      </div>
                      <div class="error">
                        <em
                          *ngIf="formService.validateControl('password') && formService.hasError('password', 'required')"
                          i18n="@@PasswordRequiredError">
                          Passwort wird benötigt
                        </em>
                      </div>
                    </div>

                    <div class="form-group position-relative mb-2">
                      <label class="persistent" for="confirm" i18n="@@ConfirmPasswordLabel">Passwort
                        wiederholen*</label>
                      <input type="password" id="confirm" formControlName="confirm"
                        (keyup)="checkPassword($event.target.value)" class="form-control"
                        i18n-placeholder="@@RepeatPassword" placeholder="Passwort wiederholen*"
                        [ngClass]="{ 'is-invalid': formService.validateControl('confirm') }" />
                      <div class="password-requirements">
                        <span [class]="passwordIsMatching ? 'check' : ''" i18n="@@PasswordMatches">Stimmt überein</span>
                      </div>
                      <div class="error">
                        <em
                          *ngIf="formService.validateControl('confirm') && formService.hasError('confirm', 'matching')"
                          i18n="@@PasswordsNotIdenticError">
                          Passwörter müssen übereinstimmen
                        </em>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row justify-content-center mt-2">
                  <div class=" col-12 text-left">
                    <!--CheckBox-->
                    <div>
                      <!--CheckBoxAgb-->
                      <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="agbConfirm" formControlName="agbConfirm" />
                        <label class="form-check-label" for="agbConfirm" i18n="@@agbConfirmDescription">
                          Ich habe die
                          <a href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf"
                            target="_blank" class="link-yellow" style="cursor: pointer;">AGB</a>
                          der CUBOS Service GmbH gelesen und stimme diesen zu.*
                        </label>
                      </div>

                      <!--CheckBoxCancelPolicy-->
                      <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="wrbConfirm" formControlName="wrbConfirm" />
                        <label class="form-check-label" for="wrbConfirm" i18n="@@agbConfirmDescription">
                          Mir sind die Widerrufsbelehrung gemäß den CUBOS Service GmbH
                          <a href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf"
                            target="_blank" class="link-yellow" style="cursor: pointer;">AGB</a>
                          bekannt.*
                        </label>
                      </div>

                      <!--CheckBoxDsb-->
                      <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="dsbConfirm" formControlName="dsbConfirm" />
                        <label class="form-check-label" for="dsbConfirm" i18n="@@agbConfirmDescription">
                          Ich habe die
                          <a data-bs-toggle="modal" data-bs-target="dsModal" class="link-yellow" style="cursor:pointer;"
                            (click)="openDSDialog()">Datenschutzbestimmungen</a>
                          der CUBOS Service GmbH gelesen und stimme diesen zu.*
                        </label>
                      </div>

                      <!--CheckBoxInfo-->
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="infoConfirm"
                          formControlName="infoConfirm" />
                        <label class="form-check-label" for="infoConfirm" i18n="@@agbConfirmDescription">
                          Ich bin damit einverstanden, neue Informationen über Produkte der CUBOS Service GmbH per
                          E-Mail zu erhalten.
                        </label>
                      </div>
                    </div>
                  </div>
                  <p class="pt-3">Mit * gekennzeichnete Felder sind Pflichtfelder.</p>
                </div>

                <div class="row justify-content-center">
                  <div class="col-12">
                    <div class="mb-2 mt-3">
                      <button type="submit" id="register" class="w-100 btn btn-yellow "
                        [disabled]="!formService.form.valid" i18n="@@NowRegisterButton">
                        Jetzt registrieren
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row justify-content-center mt-12">
                  <div class="text-center">

                    <div class="md-4 text-center">
                      <a class="nav-link text-dark link-yellow" id="alreadyregistered" [routerLink]="['/auth/login']"
                        i18n="@@AlreadyUserGoToLoginLink">
                        Bereits registriert? Hier gehts zum Login.
                      </a>
                    </div>
                    <p class="mt-2 mb-3 text-muted">
                      <a href="https://www.cubos.com" target="_blank" style="text-decoration: none; color: #6c757d;">©
                        {{currentYearLong()}} CUBOS Service GmbH</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </main>
      <main class="form-register" *ngIf="user.isPasswordSet">
        <form class="form-shadow p-4">
          <div class="container justify-content-center">
            <div class="row justify-content-center">
              <div class="text-center">
                <a href="https://cubos.com" target="_blank"> <img class="mb-4" src="assets/images/cubos_cube_rgb.svg"
                    alt="" width="72" height="57"> </a>
                <div class="col-md-12 col mb-2">
                  <h4 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@AlreadyRegisteredFeedback">
                    Sie sind bereits registriert. Sie können sich direkt anmelden.
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center round">
            <div class="col-lg-10 col-md-12">
              <div class="form-group">
                <div class="row justify-content-center">
                  <div class="col-md-12 col-lg-10 col-12">
                    <div class="mb-1 text-center">
                      <br />
                      <button [routerLink]="['/auth/login']" id="backtologin" class="w-50 btn btn-lg btn-yellow"
                        i18n="@@BackToLoginButton">Zurück zur Anmeldung</button>
                    </div>
                    <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" target="_blank"
                        style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </main>
    </body>
  </ng-container>
</ng-container>
<ng-template #notAllowed>

  <body class="body-form-signin forbidden-bg"
    [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">
    <main class="form-register">
      <form class="form-shadow">
        <div class="container justify-content-center">
          <div class="row justify-content-center">
            <div class="text-center mt-4">
              <a href="https://cubos.com"> <img class="mb-4" src="assets/images/cubos_cube_rgb.svg" alt="" width="72"
                  height="57"> </a>
              <div class="col-md-12 col mb-2">
                <h3 class="font-weight-bold ml-md-0 mx-auto text-center" i18n="@@ForbiddenHeader">Keine Rechte für diese
                  Seite</h3>
                <h4 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@ForbiddenText">
                  Sie haben keine Rechte diese Seite aufzurufen.
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center round">
          <div class="col-lg-10 col-md-12">
            <div class="form-group">
              <div class="row justify-content-center">
                <div class="col-md-12 col-lg-10 col-12">
                  <div class="mb-1 text-center">
                    <br />
                    <button class="btn btn-yellow" id="back_to_login" (click)="navigateToLogin()"
                      i18n="@@BackToLoginButton">Zurück zur Anmeldung</button>
                  </div>
                  <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com"
                      style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </main>
  </body>

</ng-template>

<ng-template #operatorRegister>
  <div class="modal-header">
    <h5 class="modal-title" id="newUserLabel" i18n="@@CreateNewCustomerHeader">Betreibermodell (Standortpartner)</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="onCancelClick()"></button>
  </div>
  <div class="modal-body">
    <form class="was-validated hide-valid-feedback" [formGroup]="formService.form" autocomplete="off" novalidate
      (ngSubmit)="registerUserFromOperator(formService.form.value)" *ngIf="formCreated">
      <div class="justify-content-center">
        <div class="justify-content-center">
          <app-message [service]="messageService"></app-message>
        </div>

        <div class="container-fluid">
          <div class="col-lg-12 col-md-12">
            <div class="row justify-content-center">
              <div class="col-12 mt-3 mb-2">
                <div class="form-group mb-2">

                  <label class="persistent" for="type">Privat / Geschäftlich*</label>
                  <select id="type" formControlName="type" class="form-control form-select" value="company">
                    <option value="company" i18n="@@BusinessUserOption">Geschäftlich</option>
                    <option value="private" i18n="@@PrivateUserOption">Privat</option>
                  </select>
                </div>

                <div *ngIf="isTypeCompany()" class="form-group">
                  <label class="persistent" for="company" i18n="@@CompanyLabel">Unternehmen*</label>
                  <input type="text" id="company" formControlName="company" class="form-control"
                    [ngClass]="{ 'is-invalid': formService.validateControl('company') }" />

                  <div class="invalid-tooltip"
                    *ngIf="formService.validateControl('company') && formService.hasError('company', 'required')"
                    i18n="@@CompanyRequiredError">
                    Unternehmen wird benötigt
                  </div>

                </div>

              </div>
              <div class="col-lg-12">
                <div class="row mb-2">
                  <div class="col-12 col-lg-2">
                    <label class="persistent" for="gender" i18n="@@TitleLabel">Anrede*</label>
                    <select id="gender" formControlName="gender" class="form-control form-select"
                      [ngClass]="{ 'is-invalid': formService.validateControl('gender') }">
                      <option value="male" i18n="@@TitleMrOption">Herr</option>
                      <option value="female" i18n="@@TitleMrs_MsOption">Frau</option>
                      <option value="diverse" i18n="@@TitleDiversOption">Divers</option>
                    </select>
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('gender') && formService.hasError('gender', 'required')"
                      i18n="@@TitleRequiredError">
                      Anrede wird benötigt
                    </div>
                  </div>

                  <div class="col-12 col-lg-5">
                    <label class="persistent" for="firstName" i18n="@@FirstnameLabel">Vorname*</label>
                    <input type="text" id="firstName" formControlName="firstName" class="form-control"
                      [ngClass]="{ 'is-invalid': formService.validateControl('firstName') }" />
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'required')"
                      i18n="@@FirstnameRequiredError">
                      Vorname wird benötigt
                    </div>
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')"
                      i18n="@@IncorrectInputError">
                      Falsche Eingabe
                    </div>
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'maxlength')"
                      i18n="@@ExceededMaxLengthError">
                      Die Eingabe darf maximal 50 Zeichen lang sein
                    </div>
                  </div>

                  <div class="col-12 col-lg-5">
                    <label class="persistent" for="lastName" i18n="@@LastnameLabel">Nachname*</label>
                    <input type="text" id="lastName" formControlName="lastName" class="form-control"
                      [ngClass]="{ 'is-invalid': formService.validateControl('lastName') }" />
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')"
                      i18n="@@LastnameRequiredError">
                      Nachname wird benötigt
                    </div>
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')"
                      i18n="@@IncorrectInputError">
                      Falsche Eingabe
                    </div>
                    <div class="invalid-tooltip"
                      *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'maxlength')"
                      i18n="@@ExceededMaxLengthError">
                      Die Eingabe darf maximal 50 Zeichen lang sein
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-lg-12">
                <div formGroupName="address">
                  <div class="form-row row">
                    <div class="form-group position-relative col-8 mb-2">
                      <label class="persistent" for="street" i18n="@@StreetLabel">Straße*</label>
                      <input type="text" id="street" formControlName="street" class="form-control"
                        [ngClass]="{ 'is-invalid': formService.validateControl('address.street') }" />
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'required')"
                        i18n="@@StreetRequiredError">
                        Straße wird benötigt
                      </div>
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'pattern')"
                        i18n="@@IncorrectInputError">
                        Falsche Eingabe
                      </div>
                    </div>

                    <div class="form-group position-relative col-4 mb-2">
                      <label class="persistent" for="houseNumber" i18n="@@HousnumberLabel">Hausnummer*</label>
                      <input type="text" id="houseNumber" formControlName="houseNumber" class="form-control"
                        [ngClass]="{ 'is-invalid': formService.validateControl('address.houseNumber') }" />
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.houseNumber') && formService.hasError('address.houseNumber', 'required')"
                        i18n="@@HousnumberRequiredError">
                        Hausnummer wird benötigt
                      </div>
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.houseNumber') && formService.hasError('address.houseNumber', 'pattern')"
                        i18n="@@IncorrectInputError">
                        Falsche Eingabe
                      </div>
                    </div>
                  </div>
                  <div class="form-row row">
                    <div class="form-group position-relative col-4 mb-2">
                      <label class="persistent" for="postalCode" i18n="@@PostalCodeLabel">PLZ*</label>
                      <input type="text" id="postalCode" formControlName="postalCode" class="form-control"
                        [ngClass]="{ 'is-invalid': formService.validateControl('address.postalCode') }" />

                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'required')"
                        i18n="@@postalCodeRequiredError">
                        PLZ wird benötigt
                      </div>
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'pattern')"
                        i18n="@@IncorrectInputError">
                        Falsche Eingabe
                      </div>
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'maxlength')"
                        i18n="@@ExceededMaxLengthPLZError">
                        PLZ zu lang
                      </div>
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'minlength')"
                        i18n="@@MissingNumbersPLZError">
                        PLZ zu kurz
                      </div>
                    </div>

                    <div class="form-group position-relative col-8 mb-2">
                      <label class="persistent" for="city" i18n="@@CityLabel">Ort*</label>
                      <input type="text" id="city" formControlName="city" class="form-control"
                        [ngClass]="{ 'is-invalid': formService.validateControl('address.city') }" />
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'required')"
                        i18n="@@CityRequiredError">
                        Ort wird benötigt
                      </div>
                      <div class="invalid-tooltip"
                        *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'pattern')"
                        i18n="@@IncorrectInputError">
                        Falsche Eingabe
                      </div>
                    </div>
                  </div>
                  <div class="form-row row">
                    <div class="form-group position-relative col-12 mb-2">
                      <label class="persistent" for="country" i18n="@@CountryLabel">Land</label>
                      <input type="text" id="country" formControlName="country" class="form-control"
                        [ngClass]="{ 'is-invalid': formService.validateControl('address.country') }" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row row">
              <div class="form-group col-12">
                <label class="persistent" for="phone" i18n="@@PhoneLabel">Telefonnummer*</label>
                <input type="text" id="phone" formControlName="phone" class="form-control"
                  [ngClass]="{ 'is-invalid': formService.validateControl('phone') }" />
                <div class="invalid-tooltip"
                  *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'required')"
                  i18n="@@PhonenumberRequiredError">
                  Telefonnummer wird benötigt
                </div>
                <div class="invalid-tooltip"
                  *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'pattern')"
                  i18n="@@IncorrectInputError">
                  Falsche Eingabe
                </div>
                <div class="invalid-tooltip"
                  *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'minlength')"
                  i18n="@@MinLengthError">
                  Telefonnummer zu kurz
                </div>
              </div>
              <div class="form-group pt-1 mb-2">
                <label class="form-label">E-Mail</label>
                <input type="email" formControlName="email" class="form-control" />
              </div>
            </div>
            <div class="row" *ngIf="isTypeCompany()">
              <div class="col-12 mt-3 mb-2">
                <div class="row mb-2">
                  <h5>Ansprechpartner Buchhaltung</h5>
                  <div class="col-12 col-lg-2">
                    <label class="form-label" for="gender" i18n="@@TitleLabel">Anrede*</label>
                    <select class="form-control form-select" value="Bitte wählen...">
                      <option value="male" i18n="@@TitleMrOption">Herr</option>
                      <option value="female" i18n="@@TitleMrs_MsOption">Frau</option>
                      <option value="diverse" i18n="@@TitleDiversOption">Divers</option>
                    </select>
                  </div>
                  <div class="col-12 col-lg-5">
                    <label class="form-label">Vorname*</label>
                    <input type="text" class="form-control" />
                  </div>
                  <div class="col-12 col-lg-5">
                    <label class="form-label">Nachname*</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="form-group pt-1 mb-2">
                  <label class="form-label">E-Mail der Buchhaltung für Rechnung/Gutschrift</label>
                  <input type="text" class="form-control" />
                </div>
                <div class="form-group pt-1 mb-2">
                  <label class="form-label">IBAN für Rechnung/Gutschrift</label>
                  <input type="text" name="iban" class="form-control" placeholder="IBAN"
                    title="Eine deutsche IBAN hat 22 Stellen und beginnt mit DE">
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12">
            <div class="row justify-content-center">
              <div class="col-12 d-none">
                <div class="form-group position-relative">
                  <!-- <label class="persistent" for="password" data-toggle="tooltip" i18n="@@ChoosePasswordLabel">Passwort* <span *ngIf="passwordRating != ''" [class]="'password-rating-' + passwordQuality">({{ passwordRating }})</span></label> -->
                  <label class="persistent" for="password" data-toggle="tooltip"
                    i18n="@@ChoosePasswordLabel">Passwort*</label>
                  <input type="password" id="password" formControlName="password"
                    (keyup)="checkPassword($event.target.value)" class="form-control"
                    [ngClass]="{ 'is-invalid': formService.validateControl('password') }" [readonly]="isOperatorView" />
                  <div class="invalid-tooltip"
                    *ngIf="formService.validateControl('password') && formService.hasError('password', 'required')"
                    i18n="@@PasswordRequiredError">
                    Passwort wird benötigt
                  </div>
                </div>
              </div>
              <div class="col-12 d-none">
                <div class="form-group position-relative">
                  <div class="password-requirements">
                    <span [class]="passwordHasUpperCase ? 'check' : ''">Großbuchstabe</span>
                    <span [class]="passwordHasLowerCase ? 'check' : ''">Kleinbuchstabe</span>
                    <span [class]="passwordHasDigit ? 'check' : ''">Ziffer</span>
                    <span [class]="passwordHasLength ? 'check' : ''">10 Zeichen lang</span>
                    <span *ngIf="passwordHasSpecialCharacter"
                      [class]="passwordHasSpecialCharacter ? 'check' : ''">Sonderzeichen</span>
                  </div>
                </div>
              </div>
              <div class="col-12 d-none">
                <div class="form-group position-relative">
                  <label class="persistent" for="confirm" i18n="@@ConfirmPasswordLabel">Passwort wiederholen*</label>
                  <input type="password" id="confirm" formControlName="confirm" class="form-control"
                    [ngClass]="{ 'is-invalid': formService.validateControl('confirm') }" [readonly]="isOperatorView" />
                  <div class="invalid-tooltip"
                    *ngIf="formService.validateControl('confirm') && formService.hasError('confirm', 'matching')"
                    i18n="@@PasswordsNotIdenticError">
                    Passwörter müssen übereinstimmen
                  </div>
                </div>

              </div>

            </div>

          </div>
          <div class="row justify-content-center mt-2 d-none">
            <div class="col-12 text-left">
              <div class="form-inline position-relative">
                <input type="checkbox" id="acceptTos" formControlName="acceptTos" class="ms-2 form-check-input"
                  [ngClass]="{ 'is-invalid': formService.validateControl('acceptTos') }" />
                <label class="form-check-label persistent ms-2" for="acceptTos" i18n="@@AcceptTermsAndConditionsLabel">
                  Ich stimme den&nbsp;
                  <a data-bs-toggle="modal" data-bs-target="agbModal" (click)="openAGBDialog();">AGB</a>
                  &nbsp; zu.*
                </label>
                <div class="invalid-tooltip"
                  *ngIf="formService.validateControl('acceptTos') && formService.hasError('acceptTos', 'required')"
                  i18n="@@AcceptTermsAndConditionsRequiredError">
                  AGB Bestätigung wird benötigt
                </div>
              </div>

              <div class="form-inline position-relative">
                <input type="checkbox" id="acceptPrivacy" formControlName="acceptPrivacy" class="ms-2 form-check-input"
                  [ngClass]="{ 'is-invalid': formService.validateControl('acceptPrivacy') }" />
                <label class="form-check-label persistent ms-2" for="acceptPrivacy" i18n="@@AcceptPrivacyLabel">
                  Ich stimme den Bedingungen des&nbsp;
                  <a data-bs-toggle="modal" data-bs-target="dsModal" (click)="openDSDialog();">Datenschutzes</a>
                  &nbsp; zu.*
                </label>
                <div class="invalid-tooltip"
                  *ngIf="formService.validateControl('acceptPrivacy') && formService.hasError('acceptPrivacy', 'required')"
                  i18n="@@AcceptPrivacyRequiredError">
                  Datenschutz Bestätigung wird benötigt
                </div>
              </div>

              <div class="form-group">
                <input type="checkbox" id="acceptAd" formControlName="acceptAd" class="ms-2 form-check-input" />
                <label for="acceptAd" class="label persistent ms-4" i18n="@@AcceptAd">
                  Ich bin damit einverstanden, neue Informationen über Produkte der CUBOS Service GmbH per E-Mail zu
                  erhalten.
                </label>
              </div>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-4">
              <button type="submit" class="btn btn-yellow btn-block w-100" [disabled]="!formService.form.valid"
                i18n="@@NowRegisterButton">
                Jetzt anlegen
              </button>
            </div>
          </div>
        </div>
      </div>


    </form>
  </div>
</ng-template>